module.exports = __webpack_public_path__ + "static/media/no_agent_photo.a08d85d9.png";